// import api from "../services/api";


// AUTOMATIZAR A OBTENÇÃO DOS DOCUMENTOS PARA EXIBIÇÃO NA NAVEGAÇÃO, FUTURAMENTE, PARA EVITAR A NECESSIDADE DE ATUALIZAR MANUALMENTE O CÓDIGO CADA VEZ QUE UM NOVO DOCUMENTO FOR ADICIONADO.
// let docsCache= [];
// const getDocs = async () => {
//     try {
//         const res = await api.get("/expediente-docs");
//         console.log("Resposta da API:", res.data);
//         docsCache = res.data?.expedienteDocss || [];
//         console.log("Documentos armazenados no cache:", docsCache);
//         return res.data?.expedienteDocss || [];
//     } catch (err) {
//         console.error("Erro ao buscar documentos:", err);
//         return [];
//     }
// };

export const navegacaoBar = [

    {
        'page': 'Início', 'link': '/', 'menuItens': []
    },

    {
        'page': 'Sobre Nós', 'menuItens':
            [
                { 'page': 'Missão, Visão e Valores', 'link': '/informacoes?menu=SOBRE NÓS&opcao=MISSÃ VISÃO VALORES' },
                { 'page': 'Organigrama', 'link': '/informacoes?menu=SOBRE NÓS&opcao=ORGANIGRAMA' },
                { 'page': 'Serviços Locais', 'link': '/informacoes?menu=SOBRE NÓS&opcao=Serviços Locais' },
                { 'page': 'Inspectores', 'link': '/inspectores' },
                { 'page': 'Titulares da Entidade', 'link': '/titulares-entidade' },
            ],
    },
    {
        'page': 'Serviços', 'menuItens':
            [
                { 'page': 'Licenciamento de Estabelecimento Farmacêutico', 'link': '/agenda-disponivel', 'servico': 'agenda' },
                { 'page': 'Renovação de Autorização de exercício Farmacêutico', 'link': '/solicitacao-de-renovacao-de-estabelecimento', 'servico': 'renovacaoAutorizacao' },
                { 'page': 'Importação e Exportação', 'link': '/importacao-e-exportacao', 'servico': 'importacaoExportacao' },
                { 'page': 'Certificado de Produtos Controlados', 'link': '/inspeccao-regulatoria/solicitacao/certificado-produto-controlado/Produtos%20Controlados', 'servico': 'certificadoProdutoControlado' },
                { 'page': 'Desalfandegamento', 'link': '/solicitacao-de-desalfandegamento', 'servico': 'desalfandegamento' },
                { 'page': 'Controlo de Qualidade', 'link': '/opcoes/controlo-de-qualidade', 'servico': 'analiseLaboratorial' },
                { 'page': 'Farmacovigilancia e Ensaios Clinicos', 'link': '/farmacovigilancia-forlumarios', 'servico': 'farmacovigilancia' },
            ]
    },
    {
        'page': 'Legislação e Documentos', 'menuItens':
            [

                { 'page': 'Decretos', 'link': '/informacoes?menu=LEGISLACÃO E DOCUMENTOS&tipoFile=Decreto' },
                { 'page': 'Despachos', 'link': '/informacoes?menu=LEGISLACÃO E DOCUMENTOS&tipoFile=Despacho' },
                { 'page': 'Leis', 'link': '/informacoes?menu=LEGISLACÃO E DOCUMENTOS&tipoFile=Lei' },
                { 'page': 'Circulares', 'link': '/informacoes?menu=LEGISLACÃO E DOCUMENTOS&tipoFile=Circular' },
                { 'page': 'Taxas e Emolumentos', 'link': '/taxas-e-emolumentos' },
                { 'page': 'Boas Praticas Regulatorias', 'link': '/informacoes?menu=LEGISLACÃO E DOCUMENTOS&tipoFile=Boas Praticas Regulatoria' },
                // { 'page': 'Farmacovigilancia e Ensaios Clinicos', 'link': '/farmacovigilancia ' }, ///informacoes?menu=LEGISLACÃO E DOCUMENTOS&tipoFile=Decreto
                { 'page': 'Farmacovigilancia e Ensaios Clinicos', 'link': '/informacoes?menu=LEGISLACÃO E DOCUMENTOS&tipoFile=Farmacovigilancia e Ensaios Clinicos' },
                // { 'page': 'Medicamentos Aprovados', 'link': '/informacoes?menu=MEDICAMENTOS&opcao=Medicamento Aprovado' },
                { 'page': 'Outros', 'link': '/informacoes?menu=LEGISLACÃO E DOCUMENTOS&tipoFile=Outros' },

                // docsCache?.map((doc) => ({
                //     page: doc.designacao, 
                //     link: `/documentos/${doc._id}`, 
                // }))
            ]
    },
    {
        'page': 'Publicações', 'menuItens':
            [
                // site-infos?menu=FARMACOVIGILÂNCIA&opcao=Alerta&pePage=5
                { 'page': 'Alertas', 'link': '/informacoes?menu=FARMACOVIGILÂNCIA&opcao=Alerta' },
                { 'page': 'Notícias', 'link': `/view-noticia/${localStorage.getItem('noticiaId')}` },
            ]
    },

    {
        'page': 'Contactos', 'link': '/contactos', 'menuItens': []
    }
];
